import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './CardImages.style.scss';

import {
    ChangeImageName,
    SelectImage,
    EditingImageName,
    CloseEditingImage,
    ImageData
} from '../../../../Redux/Actions/Atlas/images.action';

import { ActivateSideContextMenuAction } from '../../../../Redux/Actions/Atlas/contextSideMenu.action';
import { RootState } from '../../../../Redux/Store/store';
import { isEmpty } from 'ramda';
import clearName from '../../../../utils/clearNames';
import { Observer, GLOBAL_EVENT } from '../../Observer';

const CardImage: React.FunctionComponent = () => {

    const images = useSelector((state: RootState): ImageData[] => state.imagesAtlas);
    const dispatch = useDispatch();

    const handleInputBlur = (options: { id: string, name: string }) => {
        const name_trimmed = options.name.trim().trimLeft().trimRight().trimEnd();
        if (!isEmpty(name_trimmed)) {
            dispatch(ChangeImageName({id: options.id, name: clearName(name_trimmed)}));
        }
        dispatch(CloseEditingImage());
    }

    // Cambiamos el nombre de una imagen
    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>, id: string) => {
        if (event.key === 'Enter') {
            handleInputBlur({ id, name: event.currentTarget.value });
        }
    }

    // Seleccionamos una imagen
    const handleSelectImage = (id: string) => {
        Observer.emit(GLOBAL_EVENT.IMAGE_SELECTED, id);
        dispatch(SelectImage({ id }));
    }

    return (
        <React.Fragment>
            {images.map((image: ImageData, index: number) => {
                return (
                    <div className={`animated bounceInLeft card-image ${((image.active) ? "card-image-active" : "")}`} id={`id_${image.id}`} key={index}
                        onClick={() => {
                            handleSelectImage(image.id)
                        }}
                        onContextMenu={(event) => {
                            handleSelectImage(image.id)
                            dispatch(ActivateSideContextMenuAction({
                                x: event.clientX,
                                y: event.clientY,
                                id: image.id,
                                active: true,
                            }));
                        }}
                    >
                        <div className="card-image--image">
                            <img src={image.src} alt="Imagen base" className="noselect"/>
                        </div>
                        <div className="card-image--nameImage">
                            {
                                (image.changeName)
                                    ? <input type="text" className="card-image--nameImage_input"
                                        autoFocus={true}
                                        onFocus={(event) => { event.target.select() }}
                                        defaultValue={image.name}
                                        onKeyPress={(event) => handleKeyPress(event, image.id)}
                                        onBlur={(event) => handleInputBlur({ name: event.target.value, id: image.id })}
                                        maxLength={50}
                                    />
                                    : <span onDoubleClick={() => {
                                        dispatch(EditingImageName({ id: image.id }));
                                    }}>{image.name}</span>
                            }
                        </div>
                    </div>
                )
            })}
        </React.Fragment>
    );
}

export default CardImage;